import { createMemoryHistory } from "history";

export const mainRouterHistory = createMemoryHistory();
